import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiFolderOpen = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M4 20.2782C3.45 20.2782 2.97917 20.0824 2.5875 19.6907C2.19583 19.2991 2 18.8282 2 18.2782V6.27823C2 5.72823 2.19583 5.2574 2.5875 4.86573C2.97917 4.47406 3.45 4.27823 4 4.27823H10L12 6.27823H20C20.55 6.27823 21.0208 6.47406 21.4125 6.86573C21.8042 7.2574 22 7.72823 22 8.27823H11.175L9.175 6.27823H4V18.2782L6.4 10.2782H23.5L20.925 18.8532C20.7917 19.2866 20.5458 19.6324 20.1875 19.8907C19.8292 20.1491 19.4333 20.2782 19 20.2782H4ZM6.1 18.2782H19L20.8 12.2782H7.9L6.1 18.2782Z" />
  </SvgWrapper>
);
